import{Auth0Client as a}from"@auth0/auth0-spa-js";const o=({authorizationParams:o,...t})=>new a({authorizationParams:{useRefreshTokens:!0,...o},...t});export{o as getAuth0Client};
